import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'parseFrenchDate',
  pure: true 
})
export class ParseFrenchDatePipe implements PipeTransform {
  private monthsMap: { [key: string]: string } = {
    'janv.': 'Jan', 'févr.': 'Feb', 'mars': 'Mar', 'avr.': 'Apr',
    'mai': 'May', 'juin': 'Jun', 'juil.': 'Jul', 'août': 'Aug',
    'sept.': 'Sep', 'oct.': 'Oct', 'nov.': 'Nov', 'déc.': 'Dec'
  };

  transform(value: string): string | null {
    if (!value) return null;

    const parts = value.split('-');
    if (parts.length !== 3) return null;

    const [day, monthFr, year] = parts;
    const monthEn = this.monthsMap[monthFr.toLowerCase()];
    if (!monthEn) return null;

    return `${day}-${monthEn}-${year}`;
  }
}

